import { io, Socket } from 'socket.io-client';

import { tokenService } from '@tallo/auth';

export enum AgentChatSocketEvent {
  MESSAGE = 'agent-chat:message',
  PROCESSING = 'agent-chat:processing',
  ERROR = 'agent-chat:error',
}

/**
 * The live-updates connection for the agent thread. The server authenticates the handshake with
 * the same bearer token as the REST API and scopes every emit to the signed-in user, so the
 * client only listens — it never emits. Kept as a singleton so panel remounts reuse one socket.
 */
class AgentChatSocketService {
  private socket: Socket | null = null;

  connect(): Socket {
    if (this.socket) {
      return this.socket;
    }

    this.socket = io(process.env.API_URL as string, {
      auth: { token: tokenService.getToken() },
    });

    return this.socket;
  }

  disconnect(): void {
    this.socket?.disconnect();
    this.socket = null;
  }
}

export default new AgentChatSocketService();
